import styles from "./ProductCardAvailabilityText.module.scss";
import BodyText from "../support/BodyText";

export default function ProductCardAvailabilityText() {
  return (
    <BodyText color="body-2" className={styles.availabilityText}>
      Not available at the momen
    </BodyText>
  );
}
